"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightText = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const HighlightText = highlightTextProps => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const splittedTexts = (0, _hooks.useHighlightTextRanges)(highlightTextProps);
  const {
    deliveryChannelId
  } = highlightTextProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: splittedTexts.map(({
      isHighlighted,
      substring
    }, index) => {
      const keySuffix = `${deliveryChannelId}-${substring}-${index}`;
      if (isHighlighted) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("u", {
          ...getTestIdProps(_models.TestId.HighlightedPhrase),
          children: substring
        }, `u-${keySuffix}`);
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: substring
      }, `span-${keySuffix}`);
    })
  });
};
exports.HighlightText = HighlightText;